// eslint-disable-next-line no-unused-vars
import { BASE_URL } from './host'
import { Storage } from '@yld/yun-utils-common'

// 请求异常 interceptor
export default (res, opts) => {
  // 通用异常拦截器
  // eslint-disable-next-line no-unused-vars
  const { code, msg = '网络错误', origin: { url, method, data, params, silent, report }} = res

  // 401 = 未登录/登录过期 410 = 其他地方登录  跳转登录页面
  if ((code === 401 || code === 410) && !silent) {
    localStorage.removeItem('global_auth_token')
    Storage.clearStorage()
    // 本地和测试环境
    // window && window.location.replace('http://test-iam.sdlandsea.net/#/passport/logout?client_id=1180946496460161024&response_type=code&redirect_uri=')
    // 生产环境
    window && window.location.replace('https://iam.sdland-sea.com/#/passport/logout?client_id=1180946496460161024&response_type=code&redirect_uri=https://fare.i-ebs.com')
    // 统一回调函数
    if (opts.callback && typeof opts.callback === 'function' && !silent) {
      return opts.callback(res)
    }

    // 最终返回异常
    return res
  }

  // 走自定义异常拦截器（如果有）
  if (opts.interceptor && typeof opts.interceptor === 'function') {
    return opts.interceptor(res)
  }

  return res
}
